"use client";

import { c as _c } from "react/compiler-runtime";
import { resolveIpfsUrl } from "@/components/ipfs/IPFSContext";
import { useIdentity } from "@/hooks/useIdentity";
import Image from "next/image";
import Link from "next/link";
interface ArtistPillProps {
  readonly label: string;
  readonly href?: string | undefined;
  readonly pfp?: string | null | undefined;
  readonly profileHandle?: string | undefined;
}
export default function ArtistPill(t0) {
  const $ = _c(14);
  const {
    label,
    href,
    pfp,
    profileHandle
  } = t0;
  const t1 = profileHandle ?? "";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      handleOrWallet: t1,
      initialProfile: null
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    profile
  } = useIdentity(t2);
  const resolvedPfp = pfp ?? profile?.pfp ?? null;
  const labelClassName = href ? "tw-min-w-0 tw-truncate tw-text-sm tw-font-medium tw-text-iron-200 tw-transition-colors tw-duration-300 desktop-hover:hover:tw-text-iron-100" : "tw-min-w-0 tw-truncate tw-text-sm tw-font-medium tw-text-iron-200";
  let t3;
  if ($[2] !== label || $[3] !== resolvedPfp) {
    t3 = resolvedPfp ? <Image src={resolveIpfsUrl(resolvedPfp)} alt={label} width={16} height={16} className="tw-size-4 tw-flex-shrink-0 tw-rounded-sm tw-bg-iron-900 tw-object-contain" /> : <span aria-hidden="true" className="tw-size-4 tw-flex-shrink-0 tw-rounded-sm tw-bg-iron-900" />;
    $[2] = label;
    $[3] = resolvedPfp;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== label || $[6] !== labelClassName) {
    t4 = <span className={labelClassName}>{label}</span>;
    $[5] = label;
    $[6] = labelClassName;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <span className="tw-inline-flex tw-min-w-0 tw-max-w-full tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-solid tw-border-white/10 tw-bg-white/5 tw-px-2.5 tw-py-1 tw-backdrop-blur-sm">{t3}{t4}</span>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const content = t5;
  if (!href) {
    return content;
  }
  let t6;
  if ($[11] !== content || $[12] !== href) {
    t6 = <Link href={href} className="tw-no-underline">{content}</Link>;
    $[11] = content;
    $[12] = href;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}